/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import clsx from 'clsx'
import UiPill from 'components/Ui/UiPill'

export interface UiBadgeGroupItem {
    id: string | number
    label: string
}

interface UiBadgeGroupProps {
    items: UiBadgeGroupItem[]
    value: string | number | null
    onChange: (value: any) => void
    className?: string
    disabled?: boolean
    disabledItemIds?: Array<string | number>
}

const UiBadgeGroup: React.FC<UiBadgeGroupProps> = ({
    items,
    value,
    onChange,
    className,
    disabled,
    disabledItemIds = [],
}) => {
    return (
        <div className={clsx('UiBadgeGroup flex flex-wrap gap-2', className)}>
            {items.map((item) => {
                const isActive = item.id === value
                const isItemDisabled =
                    disabled || disabledItemIds.some((disabledId) => disabledId === item.id)

                return (
                    <button
                        key={item.id}
                        type="button"
                        disabled={isItemDisabled}
                        onClick={() => {
                            if (isItemDisabled) {
                                return
                            }
                            onChange(item.id)
                        }}
                        className={clsx(
                            'transition-all duration-200 outline-none focus:outline-none',
                            isItemDisabled && 'opacity-50 cursor-not-allowed'
                        )}
                    >
                        <UiPill
                            className={clsx(
                                'cursor-pointer select-none transition-colors border',
                                isActive
                                    ? 'bg-blue-600 text-white border-blue-600 font-medium'
                                    : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
                            )}
                        >
                            {item.label}
                        </UiPill>
                    </button>
                )
            })}
        </div>
    )
}

export default UiBadgeGroup
